import { Component, OnInit } from '@angular/core';
import {formatDate} from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { CancerTreatmentModel } from 'src/app/models/CancerTreatmentModel';
import { LocalStorageService } from 'ngx-webstorage';
import { DiganosisModel } from 'src/app/models/DiganosisModel';
import { CancerTreatmentService } from 'src/app/services/CancerTreatmentService';
import swal from 'sweetalert2';
import { AntiCancerTreatmentEntryComponent } from '../anti-cancer-treatment-entry/anti-cancer-treatment-entry.component';
import { UnitsModel } from 'src/app/models/UnitsModel';
import { UnitsService } from 'src/app/services/UnitsService';

@Component({
  selector: 'app-anti-cancer-treatment',
  templateUrl: './anti-cancer-treatment.component.html',
  styleUrls: ['./anti-cancer-treatment.component.css']
})
export class AntiCancerTreatmentComponent implements OnInit {

  patientcode = '' ;
  Patientname = '';
  trdate = '2024-01-01' ;
  trtime = '2024-01-01' ;
  trlocation = '' ;
  trtype = '' ;
  trkindid = '' ;
  trkind = '' ;
  trunit = '' ;
  trcycleno = '' ;
  trdayscycle = '' ;
  trnotes = '' ;
  trstartdate = '2024-01-01' ;
  trenddate = '2024-01-01' ;
  trdose = 0 ;
  trdosemod = 0 ;
  trfrac = 0 ;
  trdosefrac = 0 ;
  userid = '' ;
  username = '' ;
  trconsultant = '';

  wk_title_of_dos : string[] = [];            //= 'Total Dose (Gy):';
  wk_title_of_Fractionation : string[] = [];  //= 'Fractionation :';
  wk_title_of_Dose_Fraction : string[] = [];  //= 'Dose per Fraction (Gy :';

  cancertreatmentList:CancerTreatmentModel[]=[];
  wk_PreviuousSite : string[] = [];
  disablepharnacy = false;
  hiddenhead = false;
  wk_date = '2000-01-01';
  wk_type = '';
  wk_font = 2;
  wk_fontsize = '2ch';
  chkuser = '';

  constructor(private dialogref: MatDialog,  public storage: LocalStorageService,
    public diganosis : DiganosisModel,
    public cancertreatmentService : CancerTreatmentService,
    public UnitsService : UnitsService) { }


  ngOnInit(): void {
        this.patientcode = this.storage.retrieve('stgPatientCode');
        this.Patientname = this.storage.retrieve('stgPatientName');
        this.trdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
        this.RetriveCancerTreatment();
        if(this.storage.retrieve('stgGroup') !='2'){this.disablepharnacy = true}else{this.disablepharnacy = false}

  }
  RetriveCancerTreatment(){
              this.cancertreatmentList = [];
               this.cancertreatmentService.getCancerTreatmentPatient(this.patientcode).subscribe((data: CancerTreatmentModel[]) => {
                this.wk_date = '2000-01-01';
                this.wk_type = '';
                for (let i = 0; i < data.length; i++) {
                    this.cancertreatmentList[i] = data[i];
                    var notes =  this.cancertreatmentList[i].trnotes;
                    this.cancertreatmentList[i].trdate =formatDate(data[i].trdate, 'yyyy-MM-dd', 'en');
                    this.cancertreatmentList[i].trstartdate =formatDate(data[i].trstartdate, 'yyyy-MM-dd', 'en');
                    this.cancertreatmentList[i].trenddate =formatDate(data[i].trenddate, 'yyyy-MM-dd', 'en');

                    if(data[i].trdosefrac == 0){this.cancertreatmentList[i].trdosefrac = null};
                    if(data[i].trfrac == 0){this.cancertreatmentList[i].trfrac = null};
                    if(data[i].trdose == 0){this.cancertreatmentList[i].trdose = null};


                                        if (data[i].trtype =='1' ){
                                          this.cancertreatmentList[i].wk_kind = '►Regimen';
                                          this.cancertreatmentList[i].trtype ='Systemic Therapy';
                                          this.cancertreatmentList[i].trtypeID = data[i].trtype
                                          this.cancertreatmentList[i].trdateID = formatDate(data[i].trdate, 'yyyy-MM-dd', 'en');
                                          this.cancertreatmentList[i].trtechnique = data[i].trkindid;
                                          this.UnitsService.getUnits(data[i].trunit, '1').subscribe((data1: UnitsModel) => {
                                          this.cancertreatmentList[i].trdoseunit = this.cancertreatmentList[i].trdose.toString() + data1.unName});
                                          this.cancertreatmentList[i].trkindid ='';
                                          this.cancertreatmentList[i].trkind =data[i].trkind;
                                          if(this.cancertreatmentList[i].trdosemod > 0){
                                            this.cancertreatmentList[i].trdosemodtext = ',Dose reduction:'+this.cancertreatmentList[i].trdosemod + '%'
                                          }
                                          else
                                          {this.cancertreatmentList[i].trdosemodtext = ''}

                                          this.cancertreatmentList[i].wk_trcycleno = ', Cycle :'
                                          this.cancertreatmentList[i].trcycleno = data[i].trcycleno + ' ';
                                          this.cancertreatmentList[i].trdayscycle =', Day:' + data[i].trdayscycle + ' ';
                                          this.cancertreatmentList[i].trstartdate =' Start Date :' + data[i].trstartdate + ' ';
                                          this.cancertreatmentList[i].trenddate =' End Date :' + data[i].trenddate + ' ';
                                          this.wk_title_of_dos[i] = '';


                                           this.wk_title_of_Fractionation[i] = '';
                                           this.cancertreatmentList[i].usernameCheck = data[i].username;
                                          this.wk_title_of_Dose_Fraction[i] = '';
                                          debugger;
                                          if (this.cancertreatmentList[i].trdate != this.wk_date ) {this.cancertreatmentList[i].trdate =formatDate(data[i].trdate, 'yyyy-MM-dd', 'en')}else{this.cancertreatmentList[i].trdate = '';this.cancertreatmentList[i].username ='';};
                                          if (this.cancertreatmentList[i].trtype != this.wk_type ) {this.cancertreatmentList[i].trtype =data[i].trtype} else{this.cancertreatmentList[i].trtype = '                          ';this.cancertreatmentList[i].username ='';this.cancertreatmentList[i].trdate = ''};

                                          this.wk_type =  this.cancertreatmentList[i].trkindid;
                                          this.wk_date =  data[i].trdateID;
                                          //this.cancertreatmentList[i].trdose =null;

                                        } ;

                                        if (data[i].trtype =='2' ){
                                          this.cancertreatmentList[i].trtype ='Radiotherapy';
                                          this.cancertreatmentList[i].trtypeID = data[i].trtype
                                          this.cancertreatmentList[i].trdateID = formatDate(data[i].trdate, 'yyyy-MM-dd', 'en');
                                          this.cancertreatmentList[i].wk_trcycleno = ',Technique :' + data[i].trkindid
                                          this.cancertreatmentList[i].wk_title_of_Dose_FractionText = ',Concomitant :'+  this.cancertreatmentList[i].trdayscycle + ',';

                                          this.cancertreatmentList[i].trtechnique = data[i].trkindid;
                                          this.cancertreatmentList[i].trkindid =data[i].trtype;
                                          this.cancertreatmentList[i].wk_kind = '►Intention of Treatment ';
                                          this.cancertreatmentList[i].trkind =data[i].trkind;
                                            this.cancertreatmentList[i].trdoseunit = ',Total Dose (Gy):'+ this.cancertreatmentList[i].trdose.toString();

                                          this.cancertreatmentList[i].trcycleno =',Fractionation :'+ data[i].trfrac ;
                                          this.cancertreatmentList[i].trdayscycle =' ,Dose per Fraction (Gy):' + data[i].trdosefrac + ' ';

                                          this.cancertreatmentList[i].trstartdate =' ,Start Date :' + data[i].trstartdate + ' ,End Date :' + data[i].trenddate ;
                                          this.cancertreatmentList[i].trenddate =' ,End Date :' + data[i].trenddate + ' ' ;

                                          this.cancertreatmentList[i].trdose =  data[i].trdose;
                                          this.cancertreatmentList[i].usernameCheck = data[i].username;
                                          this.cancertreatmentList[i].trfrac =  data[i].trfrac;
                                          this.wk_title_of_Dose_Fraction[i] = '';
                                          this.wk_title_of_dos[i] = ',Total Dose (Gy):';
                                          this.wk_title_of_Fractionation[i] = ',Fractionation :';
                                          if (this.cancertreatmentList[i].trdate != this.wk_date ) {this.cancertreatmentList[i].trdate =formatDate(data[i].trdate, 'yyyy-MM-dd', 'en')}else{this.cancertreatmentList[i].trdate = '';this.cancertreatmentList[i].username =''};
                                          if (this.cancertreatmentList[i].trtype != this.wk_type ) {this.cancertreatmentList[i].trtype =data[i].trtype} else{this.cancertreatmentList[i].trtype = '                       ';this.cancertreatmentList[i].username ='';this.cancertreatmentList[i].trdate = ''};
                                          this.wk_type =  this.cancertreatmentList[i].trkindid;
                                          this.wk_date =  data[i].trdate;

                                          this.cancertreatmentList[i].wk_Pervious = ',Previous Site :' + data[i].trunit;
                                        } ;

                    if (data[i].trtype =='3' ){
                      this.cancertreatmentList[i].wk_kind = '►';
                      this.cancertreatmentList[i].trtype ='Hormonal';
                      this.cancertreatmentList[i].trtypeID ='Hormonal';
                      this.cancertreatmentList[i].trtechnique = data[i].trkindid;
                      this.cancertreatmentList[i].trdateID = formatDate(data[i].trdate, 'yyyy-MM-dd', 'en');

                      this.cancertreatmentList[i].trkindid =data[i].trtype;
                      this.cancertreatmentList[i].trkind = data[i].trkind;
                      this.cancertreatmentList[i].trcycleno ='' + data[i].trcycleno + ' ';
                      this.cancertreatmentList[i].wk_trcycleno = ' '

                      this.cancertreatmentList[i].trdayscycle = data[i].trdayscycle + ' ';
                      this.cancertreatmentList[i].trstartdate =' Start Date :' + data[i].trstartdate + ' End Date :' + data[i].trenddate + ' ';
                      this.cancertreatmentList[i].trenddate =' End Date :' + data[i].trenddate + ' ' ;
                      this.wk_title_of_dos[i] = '';
                      this.cancertreatmentList[i].usernameCheck = data[i].username;
                      this.cancertreatmentList[i].trdose =  data[i].trdose;
                      this.wk_title_of_Fractionation[i] = '';
                      this.cancertreatmentList[i].trfrac =  data[i].trfrac;
                      this.wk_title_of_Dose_Fraction[i] = '';
                      if (this.cancertreatmentList[i].trdate != this.wk_date ) {this.cancertreatmentList[i].trdate =formatDate(data[i].trdate, 'yyyy-MM-dd', 'en')}else{this.cancertreatmentList[i].trdate = '';this.cancertreatmentList[i].username =''};
                      if (this.cancertreatmentList[i].trtype != this.wk_type ) {this.cancertreatmentList[i].trtype =data[i].trtype} else{this.cancertreatmentList[i].trtype = '';this.cancertreatmentList[i].username ='';this.cancertreatmentList[i].trdate = ''};
                      this.wk_type =  this.cancertreatmentList[i].trkindid;
                      this.wk_date =  data[i].trdate;
                    } ;
                    if (data[i].trtype =='4' ){
                      this.cancertreatmentList[i].wk_kind = '►';
                      this.cancertreatmentList[i].trtype ='Surgery';
                      this.cancertreatmentList[i].trtypeID ='Surgery';
                      this.cancertreatmentList[i].trkindid =data[i].trtype;
                      this.cancertreatmentList[i].trdateID = formatDate(data[i].trdate, 'yyyy-MM-dd', 'en');

                      this.cancertreatmentList[i].trkind =' ' + data[i].trkind;
                         this.cancertreatmentList[i].wk_trcycleno = ' '
                      this.cancertreatmentList[i].trcycleno = data[i].trcycleno + ' ';
                      this.cancertreatmentList[i].trdayscycle =',' + data[i].trdayscycle + ' ';
                      this.cancertreatmentList[i].trstartdate =' Surgery Date :' + data[i].trstartdate + ' ';
                      this.cancertreatmentList[i].trenddate =' ' ;
                      this.wk_title_of_dos[i] = '';
                      this.cancertreatmentList[i].trdose =  data[i].trdose;
                      this.wk_title_of_Fractionation[i] = '';
                      this.cancertreatmentList[i].trfrac =  data[i].trfrac;
                      this.wk_title_of_Dose_Fraction[i] = '';
                      this.cancertreatmentList[i].usernameCheck = data[i].username;
                      if (this.cancertreatmentList[i].trdate != this.wk_date ) {this.cancertreatmentList[i].trdate =formatDate(data[i].trdate, 'yyyy-MM-dd', 'en')}else{this.cancertreatmentList[i].trdate = '';this.cancertreatmentList[i].username =''};
                      if (this.cancertreatmentList[i].trtype != this.wk_type ) {this.cancertreatmentList[i].trtype =data[i].trtype} else{this.cancertreatmentList[i].trtype = ' ';this.cancertreatmentList[i].username ='';this.cancertreatmentList[i].trdate = ''};
                      this.wk_type =  this.cancertreatmentList[i].trkindid;
                      this.wk_date =  data[i].trdate;
                    } ;
                       if (data[i].trtype =='5' ){
                      this.cancertreatmentList[i].wk_kind = ' ►';
                      this.cancertreatmentList[i].trtype ='Targeted Treatment';
                      this.cancertreatmentList[i].trkindid =data[i].trtype;
                      this.cancertreatmentList[i].trkind =' ' + data[i].trkind;
                         this.cancertreatmentList[i].wk_trcycleno = ' '
                      this.cancertreatmentList[i].trcycleno = data[i].trcycleno + ' ';
                      this.cancertreatmentList[i].trdayscycle =',' + data[i].trdayscycle + ' ';
                      this.cancertreatmentList[i].trstartdate ='Start Date :' + data[i].trstartdate + ' ';
                      this.cancertreatmentList[i].trenddate =' End Date :' + data[i].trenddate + ' ';
                      this.wk_title_of_dos[i] = '';
                      this.cancertreatmentList[i].trdose =  data[i].trdose;
                      this.wk_title_of_Fractionation[i] = '';
                      this.cancertreatmentList[i].trfrac =  data[i].trfrac;
                      this.wk_title_of_Dose_Fraction[i] = '';
                      this.cancertreatmentList[i].usernameCheck = data[i].username;
                      if (this.cancertreatmentList[i].trdate != this.wk_date ) {this.cancertreatmentList[i].trdate =formatDate(data[i].trdate, 'yyyy-MM-dd', 'en')}else{this.cancertreatmentList[i].trdate = '';this.cancertreatmentList[i].username =''};
                      if (this.cancertreatmentList[i].trtype != this.wk_type ) {this.cancertreatmentList[i].trtype =data[i].trtype} else{this.cancertreatmentList[i].trtype = '                                   ';this.cancertreatmentList[i].username ='';this.cancertreatmentList[i].trdate = ''};
                      this.wk_type =  this.cancertreatmentList[i].trkindid;
                      this.wk_date =  data[i].trdate;
                    } ;
                    if (data[i].trtype =='6' ){
                      this.cancertreatmentList[i].wk_kind = '►';
                      this.cancertreatmentList[i].trtype ='Immunotherapy';
                      this.cancertreatmentList[i].trkindid =data[i].trtype;
                      this.cancertreatmentList[i].trkind =' ' + data[i].trkind;
                         this.cancertreatmentList[i].wk_trcycleno = ' '
                      this.cancertreatmentList[i].trcycleno = data[i].trcycleno + ' ';
                      this.cancertreatmentList[i].trdayscycle =',' + data[i].trdayscycle + ' ';
                      this.cancertreatmentList[i].trstartdate ='Start Date :' + data[i].trstartdate + ' ';
                      this.cancertreatmentList[i].trenddate =' End Date :' + data[i].trenddate + ' ';
                      this.wk_title_of_dos[i] = '';
                      this.cancertreatmentList[i].usernameCheck = data[i].username;
                      this.cancertreatmentList[i].trdose =  data[i].trdose;
                      this.wk_title_of_Fractionation[i] = '';
                      this.cancertreatmentList[i].trfrac =  data[i].trfrac;
                      this.wk_title_of_Dose_Fraction[i] = '';
                      if (this.cancertreatmentList[i].trdate != this.wk_date ) {this.cancertreatmentList[i].trdate =formatDate(data[i].trdate, 'yyyy-MM-dd', 'en')}else{this.cancertreatmentList[i].trdate = '';this.cancertreatmentList[i].username =''};
                      if (this.cancertreatmentList[i].trtype != this.wk_type ) {this.cancertreatmentList[i].trtype =data[i].trtype} else{this.cancertreatmentList[i].trtype = '                           ';this.cancertreatmentList[i].username ='';this.cancertreatmentList[i].trdate = ''};
                      this.wk_type =  this.cancertreatmentList[i].trkindid;
                      this.wk_date =  data[i].trdate;
                    } ;
                  }
                })
  }
  ZoomIn(){
    this.wk_font  = this.wk_font  + 0.5;
    this.wk_fontsize = this.wk_font + 'ch';
  }
  ZoomOut(){
    this.wk_font  = this.wk_font  - 0.5;
    this.wk_fontsize = this.wk_font + 'ch';
  }
  openDialog(){
    if(this.patientcode !='0000' || this.patientcode != null ){

    this.storage.store('stgTrType','')
    var wk_Date =formatDate(new Date(), 'yyyy-MM-dd', 'en')
    this.storage.store('stgVisitDate',wk_Date )

    this.storage.store('stgPatientCode',this.patientcode);
    //this.storage.store('stgVisitDate',item.trdate)

    const dialogRef = this.dialogref.open(AntiCancerTreatmentEntryComponent,
      {
        data: {
          dataKey: this.diganosis
        },
        width: '80vw',
        height: '40vw',
      });
    dialogRef.afterClosed().subscribe(result => {
      this.RetriveCancerTreatment();
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.RetriveCancerTreatment();
        dialogSubmitSubscription.unsubscribe();
      });
    }
  }
  EditDecision(item :CancerTreatmentModel){
    this.chkuser = item.usernameCheck;

    if( item.usernameCheck == this.storage.retrieve('stgusername') )
    {
    this.storage.store('stgPatientCode',item.patientcode);
    this.storage.store('stgVisitDate',item.trdateID)

    if(item.trtype == 'Systemic Therapy'){this.storage.store('stgTrType','1')};
    if(item.trtypeID == 'Radiotherapy'){this.storage.store('stgTrType','2')};
    if(item.trtype == 'Hormonal'){this.storage.store('stgTrType','3')};
    if(item.trtype == 'Surgery'){this.storage.store('stgTrType','4')};
    if(item.trtype == 'Targeted Treatment'){this.storage.store('stgTrType','5')};
    if(item.trtype == 'Immunotherapy'){this.storage.store('stgTrType','6')};


    const dialogRef = this.dialogref.open(AntiCancerTreatmentEntryComponent,
      {
        data: {
          dataKey: this.diganosis
        },
        width: '80vw',
        height: '40vw',
      });
      dialogRef.afterClosed().subscribe(result => {
      this.RetriveCancerTreatment();
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.RetriveCancerTreatment();
        dialogSubmitSubscription.unsubscribe();
      });
    }
    else
    {
      this. MesgWarrning();
    }
  }
      MesgWarrning(){

        swal({
          title: 'Check User',
          text:'Editing or deleting this medical record allowed only for: ' + this.chkuser,
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          //cancelButtonText: 'No, keep it',
        })
        ;

      }
  MessegeDelete(item :CancerTreatmentModel){
    this.chkuser = item.usernameCheck;
    if( item.username == this.storage.retrieve('stgusername') )
      {
    this.storage.store('stgPatientCode',item.patientcode);
    this.storage.store('stgVisitDate',item.trdateID)
    this.storage.store('stgtrkind',item.trtechnique)

    if(item.trtypeID == 'Systemic Therapy'){this.storage.store('stgTrType','1')};
    if(item.trtypeID == 'Radiotherapy'){this.storage.store('stgTrType','2')};
    if(item.trtypeID == 'Hormonal'){this.storage.store('stgTrType','3')};
    if(item.trtypeID == 'Surgery'){this.storage.store('stgTrType','4'); this.storage.store('stgtrkind','1')};
    if(item.trtype == 'Targeted Treatment'){this.storage.store('stgTrType','5')};
    if(item.trtype == 'Immunotherapy'){this.storage.store('stgTrType','6')};


  swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(
      () => {

        this.DeleteCancerTreatment();
        swal('Deleted!', 'Your record has been deleted.', 'success');
      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  else
  {
   this.MesgWarrning()
  }
}
DeleteCancerTreatment(){
      console.log("Date :",this.storage.retrieve('stgVisitDate')," Patient ID :",this.storage.retrieve('stgPatientCode')," Type :",this.storage.retrieve('stgTrType')," Kind :",this.storage.retrieve('stgtrkind'))
      this.cancertreatmentService.deleteCancerTreatment(this.storage.retrieve('stgVisitDate'),this.storage.retrieve('stgPatientCode'),this.storage.retrieve('stgTrType'),this.storage.retrieve('stgtrkind')).subscribe(
          (data: CancerTreatmentModel) => {
            this.RetriveCancerTreatment();
          }
        );
  }
}
